<mat-drawer-container autosize style="height: 100%;background: var(--background)">
  <mat-drawer #drawer mode="over" position="end" style="width: 640px;background: var(--background)">

    <app-previous-site-messages (copyMessage)="copyMessage($event)"></app-previous-site-messages>

  </mat-drawer>

  <div style="display: flex;height: 100%">

    <div style="flex: 1;padding: 32px 24px;overflow: auto">

      <div class="title-large" data-testid="pageTitle"
        style="display: flex;align-items: center; gap: 8px;margin-bottom: 40px">
        <span (click)="onCloseClicked.emit()" class="material-symbols-rounded"
          style="cursor: pointer;padding: 6px">west</span>
        @if (selectedSiteMessage()) {
        Edit site message
        } @else {
        New site message
        }
      </div>

      <form #multiLangForm="ngForm">

        @for (language of languageForm.controls; track language) {
        <div [formGroup]="language"
          style="margin-bottom: 40px;display: flex;flex-direction: column;gap: 12px;width: 100%;">

          <div class="title-small" style="gap: 8px;display: flex;align-items: center;margin-bottom: 24px">
            <img [alt]="language.value.iosCode + ' flag'" [ngSrc]="language.value.flagUrl" width="24" height="24"
              sizes="24">
            {{ language.value.name }} message
          </div>

          <div class="form-group">
            <label> Title</label>
            <input [attr.data-testid]="'siteTitleInput_' + language.value.iosCode" data-testid="siteTitleInput"
              formControlName="title">
          </div>

          <div class="form-group">
            <label> Message:</label>
            <textarea [attr.data-testid]="'messageInput_' + language.value.iosCode" data-testid="messageInput"
              formControlName="message" rows="4"></textarea>

          </div>
        </div>
        }
      </form>
    </div>
    <div style="flex: 1;overflow: auto; background: var(--card-background);padding: 32px 24px">
      <div class="title-large" style="display: flex;align-items: center; gap: 8px;margin-bottom: 40px">
        Select site
      </div>

      <div class="form-group">
        <label>Search site</label>
        <input id="searchSite" [formControl]="searchControl" placeholder="Start typing to search...">
        @if (sites().length > 0) {
        <div style="margin-top: 24px;">

          @for (site of sites(); track site.id) {
          <div class="search-list-item" (click)="selectSite(site)">
            <span style="flex:1">{{ site.name }} - {{ site.shortAddress }}</span>
            @if (site.id === selectedSite()?.id) {
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M22.2757 10.3035L13.6036 18.9714L9.72357 15.0914C9.22357 14.5914 8.40742 14.5914 7.90742 15.0914C7.40742 15.5914 7.40742 16.4075 7.90742 16.9075L12.6953 21.6955C12.9473 21.9474 13.2754 22.0716 13.6033 22.0716C13.9314 22.0716 14.2593 21.9477 14.5112 21.6955L24.0912 12.119C24.5912 11.619 24.5912 10.8029 24.0912 10.3029C23.587 9.79899 22.7757 9.79935 22.2757 10.3035Z"
                fill="#0000C8" />
              <path
                d="M16 0C7.17571 0 0 7.17571 0 16C0 24.8243 7.17571 32 16 32C24.8243 32 32 24.8243 32 16C32 7.17571 24.8243 0 16 0ZM16 29.4321C8.59571 29.4321 2.56786 23.4081 2.56786 16C2.56786 8.59186 8.59579 2.56786 16 2.56786C23.4042 2.56786 29.4321 8.59186 29.4321 16C29.4321 23.4081 23.4042 29.4321 16 29.4321Z"
                fill="#0000C8" />
            </svg>
            }

          </div>
          }
        </div>

        } @else {
        <div style="margin-top: 40px;text-align: center">No results</div>
        }
      </div>


    </div>

  </div>

  <div class="fab-container">
    <div style="display: flex;gap: 8px">
      <button (click)="drawer.open()" class="secondary-button">
        Previous messages
      </button>
      <button (click)="translate()" class="secondary-button" [disabled]="isTranslating()">
        @if (isTranslating()) {
        <div class="spinner"></div>
        Translating...
        } @else {
        Auto translate
        }
      </button>
    </div>

    <button (click)="createSiteMessageClicked()" [disabled]="languageForm.invalid || selectedSite() == null"
      class="primary-button" data-testid="createSiteMessage">
      Publish
    </button>
  </div>

</mat-drawer-container>
